// extracted by mini-css-extract-plugin
export var arbitraryCodeEmbed = "j7t2U";